import { useState, useEffect } from 'react'
import { isIOS, isMacOs } from 'react-device-detect'
import { StoreIcon } from '../types/locale'

export function useStoresToDisplay(initialState: StoreIcon[]) {
  const [storesToDisplay, setStoresToDisplay] = useState(initialState)
  const getStoreIcon = (store: 'apple' | 'google') =>
    initialState.find(({ id }) => id === store)!

  useEffect(() => {
    if (window.innerWidth < 1023) {
      isIOS || isMacOs
        ? setStoresToDisplay([getStoreIcon('apple')])
        : setStoresToDisplay([getStoreIcon('google')])
    }
  }, [])

  return storesToDisplay
}
